// src/components/Admin/AdminLogin.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import StatusBar from '../BBS/StatusBar';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setError(result.message);
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="admin-login">
        <div style={{ color: '#ff0040', marginBottom: '15px', fontSize: '0.85rem' }}>
          ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
        </div>

        <h2>OPERATOR ACCESS</h2>

        <div style={{ color: '#555', marginBottom: '20px', fontSize: '0.85rem' }}>
          OPHIDIA GLOBAL — SECURE TERMINAL
        </div>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            className="admin-input"
            placeholder="USERNAME"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            autoComplete="off"
          />
          <input
            type="password"
            className="admin-input"
            placeholder="PASSWORD"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <div className="admin-error">{error}</div>

          <button
            type="submit"
            className="bbs-button"
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? 'AUTHENTICATING...' : 'LOGIN'}
          </button>
        </form>

        <div style={{ marginTop: '20px' }}>
          <button
            className="bbs-back"
            onClick={() => navigate('/')}
          >
            {'<'} RETURN TO TERMINAL
          </button>
        </div>
      </div>

      <StatusBar />
    </div>
  );
}